import { useStore } from "@/store/index";
import { checkAuth } from "@/utils/common/auth";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

const useIsAuth = () => {
    const router = useRouter();
    const [isAuth, setIsAuth] = useState(false);
    const dispatchUser = useStore(state => state.dispatchUser);

    useEffect(() => {
        checkAuth(
            () => setIsAuth(true),
            () => {
                router.push("/");
                dispatchUser({ type: "RESET_USER" });
                setIsAuth(false);
            }
        );
    }, []);

    return isAuth;
};

export default useIsAuth;
